
import { NoseurObject } from "@rivtn/noseur";
import { PloutousBaseService, PloutousTrail } from "./PloutousBaseService";

export interface ITransactionRefund {
    status: number;
    external_id: string;
    transaction_id: string;
    trails: PloutousTrail[];
    extra_data: {
        payment_processor_name: string;
    }
}

export interface IManagedTransactionRefund {
    url: string;
}

export class TransactionRefundService extends PloutousBaseService {

    protected static instance: TransactionRefundService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!TransactionRefundService.instance) TransactionRefundService.instance = new TransactionRefundService();
        return TransactionRefundService.instance;
    }

    queryTransactionRefunds(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/api/v1/transaction/refund", { query: this.normalizeParams(params) }));
    }

    initiateRefund(params: any): Promise<any> {
        return this.report(this.transport.post("/api/v1/transaction/refund", params));
    }

}
